module.exports = __webpack_public_path__ + "static/media/matrix.b6933bf3.svg";